<template>
  <div id="wrapper">
    <div id="scroller" :style="scrollerStyle">
      <div class="container" v-if="content">
        <div class="time">
          <table>
            <tbody>
              <tr>
                <td width="33%">
                  <hr />
                </td>
                <td width="34%">{{ content.date }}</td>
                <td width="33%">
                  <hr />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="content" v-if="content.messages.length > 1">
          <div v-for="(message, index) in filteredMessages" :key="index">
            <div class="left">
              <img class="img _zzz_avatar" :src="message.avatar || content.avatar" />
            </div>
            <div class="right">
              <div class="top">
                <div class="name">{{ message.name || content.name }}</div>
                <div class="addtime">{{ message.time }}</div>
              </div>
              <div style="clear:both;"></div>
              <div class="contents">{{ message.content }}</div>
                <hr style="margin-right: 10px;margin-bottom: 20px;" />
            </div>
            <div style="clear: both"></div>
          </div>
        </div>

        <div class="content" v-if="content.messages.length > 0">
          <div>
            <div class="left">
              <img class="img _zzz_avatar" :src="content.messages[content.messages.length - 1].avatar || content.avatar" />
            </div>
            <div class="right">
              <div class="top">
                <div class="name">{{ content.messages[content.messages.length - 1].name || content.name }}</div>
                <div class="addtime">{{ content.messages[content.messages.length - 1].time }}</div>
              </div>
              <div style="clear:both;"></div>
              <div class="contents">{{ content.messages[content.messages.length - 1].content }}</div>
              <hr style="margin-right: 10px;margin-bottom: 20px;display: none;" />
            </div>
            <div style="clear: both">&nbsp;</div>
          </div>
        </div>

        <!-- 最底部线 -->
        <div class="_zzz_wrap_bottom_line">
          <hr />
          <div class="_zzz_wrap_dian">
            <div class="_zzz_dian"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IScroll from 'iscroll/build/iscroll-zoom'

export default {
  name: 'WechatChat',
  computed: {
    filteredMessages() {
      if (!this.content || !this.content.messages || this.content.messages.length <= 1) return [];
      return this.content.messages.slice(0, -1);
    }
  },
  props: {
    id: {
      type: String,
      default() {
        const now = new Date()
        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0')
        const day = String(now.getDate()).padStart(2, '0')
        return `${year}${month}${day}`
      }
    }
  },
  data() {
    return {
      content: null,
      scrollerStyle: {
        'transform-origin': '0px 0px',
        'transition-timing-function': 'cubic-bezier(0.1, 0.57, 0.1, 1)',
        'transition-duration': '0ms',
        transform: 'translate(0px, 0px) scale(1) translateZ(0px)'
      }
    }
  },
  async mounted() {
    await this.fetchData(this.id)
    this.initScroll()
  },
  methods: {
    initScroll() {
      this.myScroll = new IScroll('#wrapper', {
        scrollX: false,
        freeScroll: false,
        click: true,
        zoom: false,
        mouseWheel: true,
        disablePointer: true,
        disableTouch: false,
        disableMouse: false
      })
    },
    async fetchData(id) {
      try {
        const timestamp = Date.now()
        // this.$router.replace({ query: { ...this.$route.query, t: timestamp } })
        const response = await fetch(`/data/${id}.json?t=${timestamp}`)
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        const data = await response.json()
        if (!data || typeof data !== 'object') {
          throw new Error('Invalid response format')
        }
        // 确保数据格式正确
        this.content = {
          title: data.title || '',
          date: data.date || '',
          avatar: data.avatar || '',
          name: data.name || '',
          messages: Array.isArray(data.messages) ? data.messages : []
        }
        this.$root.$emit('update-title', data.title)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
  }
}
</script>

<style>
html,
body {
  height: 100%;
}

body,
* {
  margin: 0;
  padding: 0;
  text-decoration: none;
  border: 0;
  list-style-type: none;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 1.25rem;
}

#wrapper {
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #ffffff;
  background-size: contain;
}

#scroller {
  position: absolute;
  width: 100%;
  z-index: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  -ms-text-size-adjust: none;
  -o-text-size-adjust: none;
  text-size-adjust: none;
  webkit-transform: translate3d(0, 0, 0);
}

#scroller * {
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}

img {
  pointer-events: none;
  margin: 0;
  padding: 0;
  border: 0;
  max-width: 100%;
  max-height: auto !important;
}

.fy_div {
  margin: 0;
  padding: 0;
  background: white;
  position: relative;
}

.time {
  text-align: center;
  color: #999999;
  font-size: 12px;
  width: 100%;
}

.content {
  min-height: 100px;
  margin: 5px 0;
  width: 100%;
}

.content .left {
  min-height: 51px;
  float: left;
  width: 16%;
}

.content .left .img {
  width: 40px;
  margin: 10px;
}

.content .right {
  min-height: 50px;
  float: right;
  width: 84%;
  text-align: left;
}

.content .right .top .name {
  float: left;
  font-size: 12px;
  color: #999999;
  margin: 2px;
}

.content .right .top .addtime {
  float: right;
  font-size: 12px;
  color: #999999;
  margin: 2px 20px;
}

.content .right .contents {
  font-size: 16px;
  color: #000;
  margin: 6px 10px 20px 2px;
  white-space: pre-wrap;
  word-break: break-word;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

table {
  width: 100%;
}

td {
  padding: 2px;
}

hr {
  border: none;
  height: 1px;
  background-color: #eeeeee;
}

._zzz_avatar {
  border-radius: 4px;
}

._zzz_wrap_bottom_line {
  margin: 0 auto;
  width: 94%;
  position: relative;
  bottom: 43px;
}

._zzz_wrap_dian {
  background-color: #fff;
  text-align: center;
  margin: 0 auto;
  padding: 0 10px;
  position: absolute;
  top: 0;
  z-index: 999;
  height: 10px;
  left: 46%;
}

._zzz_dian {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #e0e0e0;
  text-align: center;
  margin-bottom: -10px;
}
</style>